(ns manatee.annotation.styles
  (:refer-clojure :exclude [rem])
  (:require [garden.color :refer [rgb]]
            [garden.units :refer [rem]]
            [rothko.styles.vars.common :refer [font-sizes font-weights line-heights]]))

(def main-styles
  [[:p.misspelled-words {:text-decoration :underline
                         :text-decoration-color (rgb 180 0 0)
                         :text-decoration-style :wavy}]
   [:p.preformatted-text {:white-space "pre-wrap"}]
   [:.annotation__view {:display :flex
                        :flex-direction :column
                        :justify-content :center
                        :padding-bottom "80px"}
    [:.accordion {:min-height "25px"}]
    [:p.answer-text {:white-space :pre-wrap}]
    [:div.text-annotation-scoring {:padding-top "10px"}]
    [:.feedback__reported-comment {:padding [[(rem 1) 0]]}]
    [:.feedback__comment {:padding [[(rem 1) 0]]}
     [:&.no-report {:padding-top 0}]]
    [:.feedback__warning {:color :orange}]
    [:.feedback__complete {:color :green}]
    [:.annotation__score {:padding [[(rem 2) 0 0]]}
     [:.radio__container {:display :flex
                          :flex-direction :row-reverse
                          :justify-content :flex-end
                          :align-items :center}]
     [:.radio__options-container {:margin-right (rem 2)}]]
    [:.annotation__previous {:border-bottom [["1px" :solid :black]]
                             :margin-bottom (rem 1)}]
    [:.annotation__status {:padding-top "1rem"
                           :display :flex}
     [:p {:padding "0 1rem"
          :color :orange}
      [:&.annotated, :&.done {:color :green}]
      [:&.rejected {:color :red}]]]
    [:.default-style-in-markdown {:margin-top "-16px"    ; Cancel out changes to the margins around so perceived margins above
                                  :margin-bottom "-6px"} ; and below the markdown container are the same as before this commit.
     [:&.expandable-text.expanded {:margin-top "-18px"   ; Margins were a bit different in the expandable-text component.
                                   :margin-bottom "-8px"}]
     [:p :blockquote :ul :li :ol {:margin :revert
                                  :padding :revert
                                  :list-style :revert}]]
    [:.checkbox__ai-hybrid {:padding-top "3rem"
                            :padding-bottom "1rem"}]]
   [:.announcements {:border [[(rem 0.5) :solid :grey]]
                     :flex-shrink 0
                     :padding (rem 1)
                     :max-width "1100px"}]
   [:.announcement {:background-color :transparent
                    :margin-bottom (rem 1)}]
   [:.audio-wave-player-title.expandable-text.expanded
    [:p {:font-size (:medium-large font-sizes)
         :font-weight (:semi-bold font-weights)
         :line-height (:medium-large line-heights)}]]
   [:.loading__view {:position :relative
                     :top "50%"
                     :text-align :center}]
   [:.answer-item-preview {:max-height "20px" ;; matches existing styling when text fits on a single line, but will crop if text wraps
                           :overflow "hidden"}]
   [:.editor-info-text {:height "40px"
                        :display :flex
                        :flex-direction :row
                        :justify-content :space-between}
    [:p.editor-info-left {:flex :auto
                          :text-align :left
                          :margin "4px"}]
    [:p.editor-info-right {:flex :auto
                           :text-align :right
                           :margin "4px"}]]])

(def modal-styles
  [[:.panel.panel-modal__panel {:overflow :visible}]
   [:.modal-form__actions {:display :flex}
    [:button:first-child {:margin-right (rem 0.5)}]
    [:button:last-child {:margin-left (rem 0.5)}]]
   [:.notes [:textarea {:width "100%"}]]])

(def info-dropdown-styles
  [[:.info-dropdown {:position :relative
                     :display :inline-block}]
   [:.info-dropdown:hover [:.info-dropdown-content
                           {:display :block}]]
   [:.info-dropdown-button {:color "#50c3ca"}]
   [:.info-dropdown-content {:display :none
                             :position :absolute
                             :z-index 1
                             :background-color "#f1f1f1"
                             :min-width "160px"}]
   [:.info-dropdown-link {:color "#50c3ca"
                          :padding "12px 16px"
                          :text-decoration :none
                          :display :block}]])

(defn main
  []
  [modal-styles
   main-styles
   info-dropdown-styles])
